module.exports = __webpack_public_path__ + "img/wmxs.a55c9ce5.png";